export const ONLY_LOCKER_BRANDS = Object.freeze(['F2OKAIDI', 'F3OXYBUL']);

export function shouldForceOnlyLockersFrToFr(natures, state) {
  if (!natures?.includes('C')) return false;

  const isFranceToFrance = state.collectCountry === 'FR' && state.deliveryCountry === 'FR';
  if (!isFranceToFrance) return false;

  const brand = state.expeditionStatus?.brand;
  if (!brand) return false;

  return ONLY_LOCKER_BRANDS.includes(brand);
}
